import { render, staticRenderFns } from "./WikiPageCategoryList.vue?vue&type=template&id=06ba0002&scoped=true"
import script from "./WikiPageCategoryList.vue?vue&type=script&lang=ts"
export * from "./WikiPageCategoryList.vue?vue&type=script&lang=ts"
import style0 from "./WikiPageCategoryList.vue?vue&type=style&index=0&id=06ba0002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba0002",
  null
  
)

export default component.exports